import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  deletePoster,
  getPostersByTenantId,
  savePoster,
  updatePosterKey,
} from "./thunks";

const initialState = {
  postersByTenants: {},
  loading: true,
};

const postersSlice = createSlice({
  name: "posters",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPostersByTenantId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPostersByTenantId.fulfilled, (state, action) => {
        const { tenant_id } = action.meta.arg;
        const { data } = action.payload;

        state.postersByTenants[tenant_id] = data;
        state.loading = false;
      })
      .addCase(getPostersByTenantId.rejected, (state) => {
        state.loading = false;
      })
      .addCase(savePoster.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.postersByTenants[data?.tenant_id].unshift(data);
        message.success("Poster added successfully!");
      })
      .addCase(deletePoster.fulfilled, (state, action) => {
        const { poster_id, tenant_id } = action.meta.arg;

        state.postersByTenants[tenant_id] = state?.postersByTenants[
          tenant_id
        ]?.filter((poster) => poster?.id !== poster_id);

        message.success("Poster deleted successfully!");
      })
      .addCase(updatePosterKey.fulfilled, (state, action) => {
        const { url } = action.payload;
        const { tenant_id, poster_id } = action.meta.arg;
        const index = state.postersByTenants[tenant_id]?.findIndex(
          ({ id }) => id === poster_id,
        );
        if (index !== -1) {
          state.postersByTenants[tenant_id][index].content = url;
        }
      });
  },
});

export const { setKeyValue } = postersSlice.actions;

export default postersSlice.reducer;
